const formatSizeInfo = (group, value) => {
  if (!group || !value) return '';
  return `${group}:${value}`;
};

const combineSizeInfo = (primaryInfo, secondaryInfo) => {
  if (primaryInfo && secondaryInfo) {
    return `${primaryInfo}-${secondaryInfo}`;
  }
  return primaryInfo || secondaryInfo || '';
};

const getSelectedProductSizeInfo = (productPageState) => {
  if (!productPageState?.collectionData) return '';

  const { collectionData } = productPageState;
  const { activeProduct, primarySizeGroup, secondarySizeGroup } = collectionData || {};
  const { tileOptions } = activeProduct || {};

  const primarySizeValue = tileOptions?.primarySize?.split('_')[0] || '';
  const secondarySizeValue = tileOptions?.secondarySize?.split('_')[0] || '';

  const primarySizeInfo = formatSizeInfo(primarySizeGroup, primarySizeValue);
  const secondarySizeInfo = formatSizeInfo(secondarySizeGroup, secondarySizeValue);

  return combineSizeInfo(primarySizeInfo, secondarySizeInfo);
};

export default getSelectedProductSizeInfo;
